export default __webpack_public_path__ + "static/media/resnetgru4.49f870f3.png";